var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(69, 110, 141)",
    height: "25px",
    width: "25px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452.546,0.446c-1.336,0.312-264.687,66.157-267.378,66.83c-7.372,1.84-12.647,8.546-12.647,16.197 c0,10.534,0,297.654,0,308.2c-14.352-8.573-31.815-13.239-50.088-13.239c-47.958,0-83.48,30.983-83.48,66.784 c0,35.947,35.705,66.784,83.48,66.784c47.958,0,83.479-30.983,83.479-66.784V196.684l233.743-58.436v153.248 c-14.352-8.573-31.815-13.239-50.088-13.239c-47.958,0-83.48,30.983-83.48,66.784c0,35.947,35.705,66.784,83.48,66.784 c47.958,0,83.48-30.983,83.48-66.784c0-18.677,0-312.438,0-328.353C473.047,5.961,463.041-2.004,452.546,0.446z M122.433,478.609 c-27.151,0-50.088-15.291-50.088-33.392s22.937-33.392,50.088-33.392s50.088,15.291,50.088,33.392 S149.583,478.609,122.433,478.609z M389.568,378.433c-27.151,0-50.088-15.291-50.088-33.392s22.937-33.392,50.088-33.392 s50.088,15.291,50.088,33.392S416.718,378.433,389.568,378.433z M439.656,103.828l-233.743,58.437V96.508l233.743-58.436V103.828z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/musicNote.0ef8edfb2f9762806c000a0f15db12e8.svg";
export { ForwardRef as ReactComponent };